import React from "react";
import { getShortVersion } from "../utils/version";

interface VersionBadgeProps {
  className?: string;
}

export const VersionBadge: React.FC<VersionBadgeProps> = ({ 
  className = "ml-2 px-2 py-1 bg-indigo-100 text-indigo-600 text-xs font-medium rounded-full" 
}) => {
  return (
    <span className={className}>
      {getShortVersion()}
    </span>
  );
};
